import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async getPropietCondoList({ commit, State }, {admin, condo, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/propietarios/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  getPropietCondoListMax({ commit, State }, {admin, condo}) {
    const queryString = {page: 0, size: 500};
    return API.get('/propietarios/list/' + admin.id + '/' + condo.id, {params: queryString})
      .then((response) => response.data);
  },
  async getPropietCondoById({ commit, State }, {admin, condo, propiet}) {
    const response = await API.get('/propietarios/asociar/' + admin.id + '/' + condo.id + '/' + propiet.id);
    return response;
  },
  async addPropietCondo({ commit, State }, {admin, condo, propietario}) {
    console.log('PROPIET: %o', propietario);
    const response = await API.post('/propietarios/add/' + admin.id + '/' + condo.id, propietario);
    return response;
  },
  async asociarPropietCondo({ commit, State }, {admin, condo, propUnidad}) {
    const response = await API.post('/propietarios/asociar/' + admin.id + '/' + condo.id, propUnidad);
    return response;
  },
  async disociarPropietCondo({ commit, State }, {admin, condo, condominoUnidad, fecha}) {
    const response = await API.post('/propietarios/disociar/' + admin.id + '/' + condo.id + '/'
      + condominoUnidad.relacionId + '/' + fecha);
    return response;
  },
  async getPropietarioById({ commit, State }, {admin, condo, propietario}) {
    const response = await API.get('/propietarios/get/' + admin.id + '/' + condo.id + '/' + propietario.id);
    return response;
  },
  async validateRFC({ commit, State }, {rfc}) {
    console.log('RFC: %s', rfc);
    const response = await API.post('/rfc/check/' + rfc);
    return response;
  },
  async deletePropietInquilino({ commit, State }, {adminId, condoId, propId}) {
    const response = await API.delete(`/propietarios/borrar/${adminId}/${condoId}/${propId}`);
    return response;
  },
  async updatePropietario({ commit, State}, {admin, condo, propietario}) {
    const response = await API.post(`/propietarios/update/${admin.id}/${condo.id}`, propietario);
    return response;
  },

};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
